import React from "react";
import { NumericFormat } from "react-number-format";

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, prefix, suffix, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      prefix={prefix}
      suffix={suffix}
    />
  );
};

export default NumberFormatCustom;
